import React, { useState, useEffect } from 'react'; 
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const ProtectedRouteAdmin = ({ children }) => {


    const [userAuth, setUserAuth] = useState({});
    const token = Cookies.get('auth_token');
    const userCookie = Cookies.get('auth_user');
    let user;

    const navigate = useNavigate();
    
    const url = window.location.href;
    const pathname = url.substr(url.lastIndexOf('/') + 1); 
    
  
    useEffect(() => {
        

        if (userCookie) {
            try {
                user = JSON.parse(userCookie);
            } catch (error) {
                console.error('Erreur de parsing JSON:', error);
            }
        }

        setUserAuth(user) 

        if(token == null && userAuth.role != 1){
            Cookies.set('redirect_url', `${process.env.PUBLIC_URL}/`+pathname);
            navigate(`${process.env.PUBLIC_URL}/login`)
        }
    }, []);

  
    return children;
};

export default ProtectedRouteAdmin;
